$(function(){
	var common=require("./common.js");
	var login=require("./login.js");
	var calcData=require("./calcData.js");
	var training=require("./training.js");
	var search=require("./search.js");
	var skillIconUrl=require("./skillIconUrl.js");
	var cData=calcData[cname];
	var skillList=[];
	login.init();
	// common.init();
	var detail={
		el:$(".m-macro"),
		init:function(){
			var _this=this;
			this.el.find(".applyBtn").click(function(){
				if(!isLogined){
					login.show();
					return;
				}
				serverPop.show();
			})
			this.addContent();
			this.el.find(".evaluateBtn").click(function(){
				if(!isLogined){
					login.show();
					return;
				}
				if($(this).hasClass("hasEvaluated")){
					return;
				}
				evaluatePop.show();
			})
			// this.el.find(".zanBtn").click(function(){
			// 	_this.addZan();
			// })
			this.el.find(".starBtn").click(function(){
				_this.addCollect();
			})
			this.el.find(".voteBtn").click(function(){
				var index=$(this).parent().index();
				_this.vote(index);
			})
			this.appendTag();
			this.addShare();
			this.initVote();
			// $(".macroInfo").niceScroll();
		},
		initVote:function(){
			for(var i=0;i<6;i++){
				$(".voteBtn").parent().eq(i).find(".num").html(toupiao["vote"+(i+1)]);
			}
		},
		vote:function(index){
			toupiao["vote"+(index+1)]++;
			var toupiaoStr=JSON.stringify(toupiao);
			$.getJSON("/skillmacros/updateToupiaoStrById.json?targetId="+macrosId+"&toupiaoStr="+toupiaoStr,function(msg){
				$(".voteBtn-"+(index+1)).parent().find(".num").html(toupiao["vote"+(index+1)]);
			})			
		},
		addShare:function(){
			var share = null;
		    nie.use(["nie.util.shareV5"],function(){
		        share = nie.util.share({
		            fat:".shareCnt",
		            type:1,
		            defShow:[23,22,2,1,4],
		            title:shareObj.title+shareObj.content,
		            url:shareObj.url,
		            img:shareObj.img,
		            content:null,
		            product:"ty"
		        }); 
		        $(".shareCnt .morebtn").remove();
		        $(".shareCnt .NIE-share-txt").remove();
		        $(".shareCnt").attr("style","");
		    });
		},
		addZan:function(){
			var _this=this;
			if(!isLogined){
				login.show();
				return;
			}
			$.getJSON("/skillmacros/addSkillmacrosPraise.json?id="+macrosId,function(msg){
				if(msg.resCode==11){
					login.show();
					return;
				}
				if(msg.resCode!=0){
					common.showCommonPop(msg.resReason);
					return;
				}
				var num=parseInt(_this.el.find(".zanNum").html());
				_this.el.find(".zanNum").html(num+1);
			})
		},
		addCollect:function(){
			var _this=this;
			if(!isLogined){
				login.show();
				return;
			}
			if(isCollect){
				$.getJSON("/skillmacros/deleteByCollectId.json?id="+macrosId,function(msg){
					if(msg.resCode==11){
						login.show();
						return;
					}
					if(msg.resCode!=0){
						common.showCommonPop(msg.resReason);
						return;
					}
					var num=parseInt(_this.el.find(".collectNum").html());
					_this.el.find(".collectNum").html(num-1);
					isCollect=false;
				})
			}else{
				$.getJSON("/skillmacros/addSkillmacrosCollection.json?id="+macrosId,function(msg){
					if(msg.resCode==11){
						login.show();
						return;
					}
					if(msg.resCode!=0){
						common.showCommonPop(msg.resReason);
						return;
					}
					var num=parseInt(_this.el.find(".collectNum").html());
					_this.el.find(".collectNum").html(num+1);
					isCollect=true;
				})
			}
			
		},
		addContent:function(){
			if(macrosContent!=null){
				var html="";
				for(var i=0;i<macrosContent.macroList.length;i++){
					if(macrosContent.macroList[i]=="") continue;
					var img=skillIconUrl.getUrl(macrosContent.macroList[i]);					
					if(img!=""){
						html+="<img src='"+img+"' width='40' height='40'>"
					}
					html+=macrosContent.macroList[i];
					html+="<br>";
				}
				this.el.find(".macroInfo").html(html);
			}
			//添加分数
			tuijian=common.toDecimal(tuijian);
			$(".applyCnt .num").html(tuijian+"分");
			if(tuijian=="0.0"){
				$(".applyCnt .num").html("暂无");
			}
			var starCount=tuijian/2;
			var floor=Math.floor(starCount);
			var ceil=Math.round(starCount);
			var html='';
			for(var i=0;i<floor;i++){
				this.el.find(".starCnt").append('<i class="star"></i>');
			}
			if(ceil>floor){
				this.el.find(".starCnt").append('<i class="star star-half"></i>');
			}
		},
		appendTag:function(){
			if(tag!=null){
				if(tag.type==0){
					this.el.find(".titleCnt").append('<span class="u-tags u-tags-pvp">PVP</span>');
					this.el.find(".tagCnt").append('<span class="u-tags u-tags-pvp">PVP</span>');
				}else{
					this.el.find(".titleCnt").append('<span class="u-tags u-tags-pve">PVE</span>');
					this.el.find(".tagCnt").append('<span class="u-tags u-tags-pve">PVE</span>');
				}
				for(var i in tag.list){
					this.el.find(".tagCnt").append('<span class="u-tags u-tags-pvp">'+tag.list[i]+'</span>');
				}
			}
		}
	}
	
	var evaluatePop={
		el:$(".m-evaluatePop"),
		evaluate:0,
		recommend:0,
		init:function(){
			var _this=this;
			this.el.find(".closeBtn").click(function(){
				_this.el.hide();
			})
			this.el.find(".submitBtn").click(function(){
				_this.submit();
			})
			this.el.find(".star").click(function(){
				var index=$(this).index();
				_this.refreshRecommend(index);
				_this.recommend=index+1;
			})

		},
		refreshRecommend:function(index){
			for(var i=0;i<=index;i++){
				this.el.find(".star").eq(i).addClass("active");
			}
			for(i=index+1;i<5;i++){
				this.el.find(".star").eq(i).removeClass("active");
			}
		},
		submit:function(){
			if(this.recommend==0){
				common.showCommonPop("您还未做任何评价，期待您的点评");
				return;
			}
			$.getJSON("/skillmacros/updateTuijianById.json?targetId="+macrosId+"&tuijian="+this.recommend,function(msg){
				if(msg.resCode==11){
					return;
				}
				if(msg.resCode!=0){
					common.showCommonPop(msg.resReason);
					return;
				}
				$(".m-macro .evaluateBtn").addClass("hasEvaluated").html("已评价").attr("title","您已提交宝贵的评价，感谢您对技能宏库的支持！");
			})
			this.el.hide();
			
		},
		show:function(){
			this.el.show();
		},
		hide:function(){
			this.el.hide();
		}
	}

	var serverPop={
		el:$(".m-serverPop"),
		buckNameServers:null,
		servers:null,
		selectedBuckName:null,
		selectedServer:null,
		allRoleList:[],
		init:function(){
			var _this=this;
			this.el.find(".closeBtn").click(function(){
				_this.hide();
			})
			this.el.find(".serverConfirmBtn").click(function(){
				_this.hide();
				rolesPop.show();
			})
			this.el.click(function(e){
				if($(e.target).hasClass("areaBtn")){
					_this.el.find(".areaBtn").removeClass("active");
					$(e.target).addClass("active");
					_this.selectedBuckName=$(e.target).html();
					_this.refreshServers();
				}
				if($(e.target).hasClass("serverBtn")){
					_this.el.find(".serverBtn").removeClass("active");
					$(e.target).addClass("active");
					_this.selectedServer=$(e.target).attr("data-id");
				}
			})
			this.getRoleList();			
		},
		getRoleList:function(){
			var _this=this;
			$.getJSON("/app/rolebind/rolelistForWeb.json?bindStatus=-1&limit=100&offset=0",function(msg){
				if(msg.resCode==0){
					_this.allRoleList=msg.data;
					_this.getServerList();
				}				
			})
		},
		getServerList:function(){
			var _this=this;
			// if(window.location.hostname=="hd.tianyu.163.com"){
			// 	_this.buckNameServers={"开天辟地":{"10009":"星茸花语","10001":"梦回苏澜"},"云垂盛世":{"10031":"浮生若梦","10060":"烟雨沧澜"}};
			// 	_this.servers={"servers":{"10001":"梦回苏澜","10009":"星茸花语","10031":"浮生若梦","10060":"烟雨沧澜"}};
			// 	_this.refreshBuckName();
			// }else{
				$.getJSON("/rank/getServerInfo.json?callback=?",function(msg){
					// msg=rootmsg;
					_this.buckNameServers=msg.data.buckNameServers;
					_this.servers=msg.data.servers;
					_this.refreshBuckName();
				})
			// }		
		},
		displayAllServers:function(){
			var html='';
			for(var i in this.servers){
				html+='<a href="javascript:;" class="serverBtn" data-id="'+i+'">'+this.servers[i]+'</a>';
			}
			this.el.find(".serverCnt").html(html);
		},
		refreshBuckName:function(){
			var html='';
			for(var i in this.buckNameServers){
				html+='<a href="javascript:;" class="areaBtn">'+i+'</a>';
			}
			this.el.find(".areaCnt").html(html);
			this.el.find(".areaBtn").eq(0).click();

			if(i==undefined){
				this.displayAllServers();
			}
			
		},
		refreshServers:function(){
			var html='';
			var serverMap=this.buckNameServers[this.selectedBuckName];
			for(var i in serverMap){
				html+='<a href="javascript:;" class="serverBtn" data-id="'+i+'">'+serverMap[i]+'</a>';
			}
			this.el.find(".serverCnt").html(html);
		},
		show:function(){
			this.el.show();
		},
		hide:function(){
			this.el.hide();
		}
	}

	var rolesPop={
		el:$(".m-rolesPop"),
		roleList:[],
		selsectedGbid:"",
		init:function(){
			var _this=this;
			this.el.find(".closeBtn").click(function(){
				_this.hide();
			})
			this.el.find(".backBtn").click(function(){
				serverPop.show();
				_this.hide();
			})
			this.el.find(".confirmBtn").click(function(){
				_this.applyMacros();
				// _this.hide();
			})
			this.el.on("click",".roleBtn",function(e){
				_this.el.find(".roleBtn").removeClass("active");
				$(this).addClass("active");
				_this.selsectedGbid=$(this).attr("data-gbId");
			})
		},
		getRoleList:function(){
			var allRoleList=serverPop.allRoleList;
			var selectedServer=serverPop.selectedServer;
			this.roleList=[];
			for(var i in allRoleList){
				if(allRoleList[i].server==selectedServer&&allRoleList[i].school==macroSchool){
					this.roleList.push(allRoleList[i]);
				}
			}
			if(this.roleList.length==0){
				common.showCommonPop("该服务器下没有此宏对应的职业角色，请重新选择服务器或前往游戏创建角色");
				return;
			}
			var source   = $("#roleItem-template").html();
			var template = Handlebars.compile(source);
			var html    = template({list:this.roleList});
			$(".rolesCnt").html(html);
			this.el.show();
		},
		applyMacros:function(){
			var _this=this;
			if(this.selsectedGbid==""){
				common.showCommonPop("请选择角色信息！");
				return;
			}
			$.getJSON("/skillmacros/addSkillmacrosApply.json?gbId="+this.selsectedGbid+"&targetId="+macrosId,function(msg){
				if(msg.resCode==2){
					common.showCommonPop("请保持游戏角色在线，重新应用该宏！");
					return;
				}
				if(msg.resCode==3){
					common.showCommonPop("宏库已满暂时无法新增宏！");
					return;
				}
				if(msg.resCode!=0){
					common.showCommonPop("应用失败");
					return;
				}
				common.showCommonPop("恭喜，宏应用成功<br>请前往游戏体验宏效果！");
				var num=parseInt($(".zanNum").html());
				$(".zanNum").html(num+1);
				_this.hide();
			})
		},
		show:function(){
			this.selsectedGbid="";
			this.getRoleList();			
		},
		hide:function(){
			this.el.hide();
		}
	}

	detail.init();
	evaluatePop.init();
	serverPop.init();
	rolesPop.init();

})



//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/detail.js
// module id = 0
// module chunks = 3